import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { ToastProvider } from './ToastProvider';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './config/sentry';
import { isFlagEnabled } from './config/featureFlags';
import { initLocaleFromNavigator, t } from './i18n';
import AtlasVivoTokensDemo from './design/atlasVivo/AtlasVivoTokensDemo';
import AtlasVivoShell from './design/atlasVivo/AtlasVivoShell';
import NediBrowserGallery from './design/nedi/NediBrowserGallery';
import NediWorkspaceAnatomy from './design/nedi/NediWorkspaceAnatomy';
import { mountNediTheme } from './design/nedi/mountNediTheme';

initSentry();
initLocaleFromNavigator();
// Service worker registra dentro de App (ToastProvider) — toast de update SW.

// Pin vendored nedi-ui-web (contract 2.0.0) for Atlas shell + gallery.
mountNediTheme();

// Rotas de demonstração isoladas do overhaul Atlas Vivo
// (docs/plans/overhaul-ux-atlas-vivo.md), atrás de flags locais — o app padrão
// (<App />) nunca muda de comportamento por causa disso.
//   ?atlasVivoDemo=1  → página de tokens (fase 1.2).
//   ?atlasVivoShell=1 → shell puro com placeholders, pra testar layout isolado.
//   ?nediGallery=1    → harness nedi-ui-web (plano 0.3 browser).
//   ?nediAnatomy=1    → Aceite 2.3/2.4 workspaces + offline/destructive.
// A flag `atlasVivo` de verdade (shell integrado com o mapa real) é tratada
// DENTRO de App.js, escolhendo AtlasVivoLayout — não aqui.
const showNediGallery = isFlagEnabled('nediGallery');
const showNediAnatomy = isFlagEnabled('nediAnatomy');
const showAtlasVivoDemo = !import.meta.env.PROD && isFlagEnabled('atlasVivoDemo');
const showAtlasVivoShell = !import.meta.env.PROD && isFlagEnabled('atlasVivoShell');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {showNediGallery ? (
      <NediBrowserGallery />
    ) : showNediAnatomy ? (
      <NediWorkspaceAnatomy />
    ) : showAtlasVivoDemo ? (
      <AtlasVivoTokensDemo />
    ) : showAtlasVivoShell ? (
      <AtlasVivoShell />
    ) : (
      <ErrorBoundary
        title={t('web.errorBoundary.title')}
        message={t('web.errorBoundary.message')}
      >
        <ToastProvider>
          <App />
        </ToastProvider>
      </ErrorBoundary>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
